import { Link } from 'react-router-dom';
import { ArrowL } from '../components/Icons.jsx';
import SEO from '../components/SEO.jsx';

export default function NotFound() {
  return (
    <main className="notfound">
      <SEO title="404 — דף לא נמצא" description="הדף שחיפשת לא קיים. חזרה לדף הבית של FocusMode." />
      <div className="wrap" style={{ padding: '120px 0', textAlign: 'center' }}>
        <div className="svc-eyebrow" style={{ justifyContent: 'center' }}>
          <span className="svc-eyebrow-bar"></span>404
        </div>
        <h1 className="contact-h1" style={{ textAlign: 'center' }}>
          הדף הזה <span className="hl-block tilt-r">לא קיים</span>.
        </h1>
        <p className="pre" style={{ maxWidth: 480, margin: '16px auto 32px', color: 'var(--muted)', lineHeight: 1.6 }}>
          {'אולי הקישור שגוי.\nאולי הדף ירד.\nבכל מקרה, חזרה הביתה.'}
        </p>
        <Link className="svc-cta" to="/" style={{ display: 'inline-flex' }}>
          <ArrowL size={14} />חזרה לדף הבית
        </Link>
      </div>
    </main>
  );
}
